import { Box, FormControl, Typography } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import React, { memo, useEffect, useState } from 'react'
import Delete from '@mui/icons-material/Delete'
import AddIcon from "@mui/icons-material/Add";
import { FormOneSeasonRuleEdit } from './FormOneSeasonRuleEdit'
import { generateRandomID } from 'helpers/generateRandomID'

export const FormSeasonRuleEdit = memo((props) => {
  const { setRulesKeys, setRules, rulesKeys, rules, rule } = props.ruleHandlers
  const [seasons, setSeasons] = useState([{id: generateRandomID(32), firstMonth: 0, secondMonth: 0}])
  const [months, setMonths] = useState([])
  const [monthsLeft, setMonthsLeft] = useState([0,1,2,3,4,5,6,7,8,9,10,11])

  useEffect(() => {
    const seasonsArray = []
    let year = new Set()
    let restOfYear = new Set([0,1,2,3,4,5,6,7,8,9,10,11])
    seasons.forEach(season => {
      let month = season.firstMonth
      const end = season.secondMonth
      while(true) {
        if(month === end) break
        year.add(month)
        restOfYear.delete(month)
        month++
        if(month === 12) month = 0
      }
      year.add(month)
      restOfYear.delete(month)
      const seasonRange = season.firstMonth === season.secondMonth ? season.firstMonth : `${season.firstMonth}-${season.secondMonth}`
      seasonsArray.push(seasonRange)
    })
    year = Array.from(year)
    setMonths(year)
    restOfYear = Array.from(restOfYear)
    setMonthsLeft(restOfYear)
    if(seasonsArray.length > 0 && year.length === 12) {
      setRulesKeys([...rulesKeys.filter(item => item.idRule !== rule.id),{idRule: rule.id, idRuleKey: seasonsArray.toString()}])
      setRules(rules.map(item => {
        if (item.id === rule.id) return {...rule, isComplete: 'good'}
        else return item
      }))
    } else {
      setRules(rules.map(item => {
        if (item.id === rule.id) return {...rule, isComplete: 'bad'}
        else return item
      }))
      setRulesKeys([...rulesKeys.filter(item => item.idRule !== rule.id)])
    }
  }, [seasons])

  return (
    <>
      <Box style={{display: 'flex', justifyContent: 'space-between', marginTop: 30, width: '98%'}}>
        <Typography style={{ alignSelf: 'center' }}>Agregar Temporada</Typography>
        <RegularButton 
          disabled={months.length === 12} 
          round 
          justIcon 
          color="info" 
          style={{ margin: 10 }} 
          onClick={() => setSeasons([...seasons, {
            id: generateRandomID(32), 
            firstMonth: months.length > 0 ? monthsLeft[0] : 0,
            secondMonth: months.length > 0 ? monthsLeft[0] : 0 
          }])}
        >
          <AddIcon style={{ margin: 0 }}/>
        </RegularButton>
      </Box>
      {
        seasons.map(season => (
          <FormControl key={season.id} style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            gap: 10, 
            marginTop: 20, 
            alignItems: 'center', 
            flexDirection: 'row', 
            width: '90%'
          }}>
            <FormControl style={{display: 'flex', justifyContent: 'space.between', gap: 10, flexDirection: 'row', flexGrow: 1}} variant="outlined">
              <FormOneSeasonRuleEdit key={season.id} months={months} season={season} seasons={seasons} setSeasons={setSeasons}/>
            </FormControl>
            <RegularButton 
              round 
              justIcon 
              color={"danger"} 
              style={{ margin: 0 }}
              disabled={seasons.length === 1} 
              onClick={(e) => {
                e.stopPropagation()
                setSeasons(seasons.filter(item => item.id !== season.id))
              }}
            >
              <Delete style={{ margin: 0 }}/>
            </RegularButton>
          </FormControl>
        ))
      }
    </>
  )
})
